import type { StoryScope } from "../../types/storyMap";

/** The little a page needs to know to link to a story. */
export interface StoryPathInput {
  id: string;
  project_id: number | null;
  folder_id?: number | null;
  scope?: StoryScope;
}

/**
 * Where a story's pages live.
 *
 * Project stories keep their project URLs (links already shared keep working);
 * folder and organisation-wide stories have no project to sit under and use
 * the scope-agnostic routes. Both families render the same pages.
 */
export const storyMapPaths = {
  builder: (s: StoryPathInput) => `${base(s)}`,
  preview: (s: StoryPathInput) => `${base(s)}/preview`,
  print: (s: StoryPathInput) => `${base(s)}/print`,
  /** Where the builder's back arrow goes: the project's story list, or the listing's folder. */
  back: (s: StoryPathInput) => {
    if (s.project_id !== null && s.project_id !== undefined) return `/projects/${s.project_id}/story-maps`;
    return s.folder_id ? `/projects?folder=${s.folder_id}` : "/projects";
  },
};

function base(s: StoryPathInput): string {
  return s.project_id !== null && s.project_id !== undefined
    ? `/projects/${s.project_id}/story-maps/${s.id}`
    : `/story-maps/${s.id}`;
}
